import {Alpha3CountryCode} from '../utils/countryCodes';

export type PhoneNumber = {
  number: string;
  prefix: string;
  countryCode: Alpha3CountryCode;
};
